<template>
  <div class="container">
    <div v-if="error" class="alert alert-danger" role="alert">
      {{ error }}
    </div>
    <div v-if="!showResetPassword">
      <mad-form @submit.prevent="submit">
        <mad-form-item label="Email">
          <mad-input v-model="form.email" />
        </mad-form-item>
        <mad-form-item label="Password">
          <mad-input v-model="form.password" type="password" />
        </mad-form-item>
        <div class="spaced-row">
          <mad-button @click="toggle()">Reset password</mad-button>
          <div class="grow"></div>
          <mad-button @click="submit()">Login</mad-button>
        </div>
      </mad-form>
    </div>
    <div v-else>
      <mad-form @submit.prevent="submit">
        <mad-form-item>
          <mad-input v-model="form.email" />
          <br>
          <div class="spaced-row">
            <mad-button @click="toggle()">Back to login</mad-button>
            <div class="grow"></div>
            <mad-button @click="send(form.email)">Reset</mad-button>
          </div>
        </mad-form-item>
      </mad-form>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    showResetPassword: false,
    form: {
      email: '',
      password: '',
    },
    error: null,
  }),

  methods: {
    toggle() {
      this.showResetPassword = !this.showResetPassword
    },

    async submit() {
      try {
        await this.$store.dispatch('login', this.form)
        this.$router.push('/locations')
      } catch (e) {
        this.error = e.message
      }
    },

    async send(email) {
      await this.$store.dispatch('resetPasswordEmail', { email })
      this.$mad.message.success(`Email has been send to: ${email}`)
      this.$router.push('/login')
    },
  },
}
</script>

<style>
</style>
